import React, { Suspense } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router';
import { Loader } from './icons/Loader';
import Layout from './components/Layout';

const Home = React.lazy(() => import('./pages/Home'));
const Goals = React.lazy(() => import('./pages/Goals'));
const Students = React.lazy(() => import('./pages/Students'));
const StudentProgress = React.lazy(() => import('./features/students/StudentProgress'));
const StudentRatings = React.lazy(
  () => import('./features/students/StudentRatings')
);
export type Handle = {
  isPrimary: boolean;
};

const PageWithLoader = ({ component }) => {
  return (
    <Suspense
      fallback={
        <div className="absolute inset-0">
          <div className="flex items-center justify-center h-full">
            <Loader className="stroke-primary" width={100} height={100} />
          </div>
        </div>
      }
    >
      {component}
    </Suspense>
  );
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <PageWithLoader component={<Home />} />,
        handle: { isPrimary: true } as Handle,
      },
      {
        path: 'goals',
        element: <PageWithLoader component={<Goals />} />,
        handle: { isPrimary: true } as Handle,
      },
      {
        path: 'goals/:goalId',
        element: <PageWithLoader component={<StudentRatings />} />,
      },
      {
        path: 'students',
        element: <PageWithLoader component={<Students />} />,
        handle: { isPrimary: true } as Handle,
      },
      {
        path: 'students/:studentId/progress',
        element: <PageWithLoader component={<StudentProgress />} />,
      },
    ],
  },
]);

export function App() {
  return (
    <div className="bg-page min-h-svh transform-gpu will-change-transform">
      <RouterProvider router={router} />
    </div>
  );
}
